import { useCallback } from 'react';
import { useAppSelector } from '@/app/hooks';
import { getTranslation, DEFAULT_LOCALE } from '@/lib/utils/i18n';

// Active-locale translation hook.
export const useTranslations = () => {
  const locale = useAppSelector((state) => state.ui?.locale) ?? DEFAULT_LOCALE;
  return useCallback((key, vars) => getTranslation(key, vars, locale), [locale]);
};
